import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-base-card',
  templateUrl: './base-card.component.html',
  styleUrls: ['./base-card.component.scss'],
})
export class BaseCardComponent {
  @Input() isLoading: boolean;
}
